import { render, staticRenderFns } from "./HtmlSitemapForm.vue?vue&type=template&id=70278ffb&"
import script from "./HtmlSitemapForm.vue?vue&type=script&lang=js&"
export * from "./HtmlSitemapForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports